export default "__VITE_ASSET__gjt2v20d__"